import React from 'react'
import { ChoiceChips } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { css } from '@linaria/core'

const chipBagCss = css`
  /* Hide the label div created by ChoiceChips */
  & div[class*='label'] {
    display: none;
  }
`

export default function FamilyChips({ selectedChip, onSelectionChange, spouseFamily, parentFamily }) {
  const [t] = useTranslation()

  const chips = [
    {
      label: t('info-cards.timeline.spouse-and-children.label'),
      value: 'spouse-and-children',
      selected: selectedChip === 'spouse-and-children',
      disabled: !spouseFamily,
    },
    {
      label: t('info-cards.timeline.parents-and-siblings.label'),
      value: 'parents-and-siblings',
      selected: selectedChip === 'parents-and-siblings',
      disabled: !parentFamily,
    },
  ]

  return (
    <div className={chipBagCss}>
      <ChoiceChips chips={chips} name="parents-and-siblings.label" onSelectionChange={onSelectionChange} />
    </div>
  )
}
